import React, { FunctionComponent } from 'react';

// MUI
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// Properties
import * as styles from './Modal.styles';

type TProps = {
    open: boolean;
    onClose: () => void;
    title: string;
}

const Modal: FunctionComponent<TProps> = ({
    open,
    onClose,
    title,
    children,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={styles.modal}
        >
            <DialogTitle sx={styles.title}>
                <Typography variant="caption" sx={styles.text}>
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={styles.close}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={styles.content}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default Modal;
